import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M17 10H7v2h10v-2zm4-7h-3V1h-2v2H8V1H6v2H3v18h18V3zm-2 16H5V8h14v11zm-5-5H7v2h7v-2z"
}), 'EventNoteSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/EventNoteSharp.js
// module id = 3422
// module chunks = 2